import { SerializedContent } from '@storyverse/shared'
import { STORY_OUTLINE_MIN_WORDS } from '../config/story-content.config'

/**
 * Checks if story content meets the minimum requirements for generating a screenplay outline
 * @param content - The serialized content array from the story
 * @returns boolean - true if content has sufficient text, false otherwise
 */
export const hasMinimalStoryContent = (content: SerializedContent[]): boolean => {
    if (!content || content.length === 0) {
        return false
    }

    // Extract all text content from the serialized content
    const allText = content.reduce((text, node) => {
        const nodeText = node.children?.map(child => child.text || '').join(' ') || ''
        return text + ' ' + nodeText
    }, '')

    // Trim and get word count
    const cleanText = allText.trim()
    const wordCount = cleanText.split(/\s+/).filter(word => word.length > 0).length
    
    // Require a meaningful amount of story context for outline generation
    return wordCount >= STORY_OUTLINE_MIN_WORDS
}

/**
 * Gets content statistics for debugging and user feedback
 * @param content - The serialized content array from the story
 * @returns object with content statistics
 */
export const getContentStats = (content: SerializedContent[]) => {
    if (!content || content.length === 0) {
        return { wordCount: 0, characterCount: 0, nodeCount: 0 }
    }

    const allText = content.reduce((text, node) => {
        const nodeText = node.children?.map(child => child.text || '').join(' ') || ''
        return text + ' ' + nodeText
    }, '')

    const cleanText = allText.trim()
    const wordCount = cleanText.split(/\s+/).filter(word => word.length > 0).length
    const characterCount = cleanText.length

    return {
        wordCount,
        characterCount,
        nodeCount: content.length
    }
}
